export class PostFinalizarViajeResquestDTO {

  movil: {
    estado: string;
    minutosEstimados: number;
    nivelCombustible: number;
  };

  conductor: {
    estado: string;
    minutosEstimados: number;
  };

  constructor() {
    this.movil = { estado:'', minutosEstimados: undefined, nivelCombustible: undefined};
    this.conductor = { estado: '', minutosEstimados: undefined};
  }

  initCampos(estadoMovil: string, nivelCombustible: number, estadoConductor: string) {
    this.movil.estado = estadoMovil;
    this.movil.nivelCombustible = nivelCombustible;
    this.movil.minutosEstimados = this.obtenerMinutosMovil(estadoMovil);
    this.conductor.estado = estadoConductor;
    this.conductor.minutosEstimados = this.obtenerMinutosConductor(estadoConductor);
  }

  obtenerMinutosMovil(estadoMovil: string): number {
    if(estadoMovil == 'EN_LAVADO')
      return 30;
    else if(estadoMovil == 'EN_LAVADO_PROFUNDO')
      return 40;
    else if(estadoMovil == 'EN_CARGA')
      return 30;

    return undefined;
  }

  obtenerMinutosConductor(estadoConductor: string): number {
    if(estadoConductor == 'EN_COLACION')
      return 30;

    return undefined;
  }


}
